/* BackToBreadcrumb — iter100.241
 *
 * Context-preserving "← Back to <origin>" breadcrumb for destination pages
 * that admins arrive at via drill-down links (Overview TAT tiles, Analytics
 * KPI tiles, etc). Reads the `?from=<origin>` query parameter and renders a
 * subtle back-link ABOVE the page hero so admins can return to where they
 * came from without hunting through the side-nav.
 *
 * Supported origins:
 *   • overview       → "Back to Overview"       (/admin)
 *   • overview-tat   → "Back to Overview"       (/admin)
 *   • analytics      → "Back to Analytics"      (/admin/analytics)
 *
 * Silently renders nothing if `?from=` is absent or unrecognised, so the
 * component can be dropped into any destination page without conditional
 * wrapping.
 */
import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

const ORIGINS = {
    overview:       { label: "Overview",  to: "/admin" },
    "overview-tat": { label: "Overview",  to: "/admin" },
    analytics:      { label: "Analytics", to: "/admin/analytics" },
};

export default function BackToBreadcrumb() {
    const [searchParams] = useSearchParams();
    const from = searchParams.get("from");
    const origin = from && ORIGINS[from];
    if (!origin) return null;

    return (
        <Link
            to={origin.to}
            className="inline-flex items-center gap-1.5 text-xs font-semibold text-muted-foreground hover:text-primary transition-colors group"
            data-testid={`back-to-${from}`}
        >
            <ArrowLeft size={12} weight="bold" className="group-hover:-translate-x-0.5 transition-transform" />
            Back to {origin.label}
        </Link>
    );
}
